import { FavouritesIcon } from "@/components/icons/favourites-icon";
import { OutlinedButton } from "@/components/ui/buttons/OutlinedButton";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface SavedFoodsOptionProps {
  disabled?: boolean;
  onClick: () => void;
}

export const SavedFoodsOption = memo(function SavedFoodsOption({
  disabled,
  onClick,
}: SavedFoodsOptionProps) {
  return (
    <OutlinedButton
      color="black"
      textCase="normal"
      disabled={disabled}
      onClick={onClick}
      className="flex items-center justify-between px-3"
    >
      <FavouritesIcon className="h-6 w-6 fill-black" />
      <span className={textVariants.bodySingleLine}>Add from Foods Added</span>
      <div className="h-6 w-6" />
    </OutlinedButton>
  );
});
